export type ExtraUiType = 'checkbox' | 'fixed' | 'incrementor';

export interface IExtraLike {
  calculationRule: string;
  postingRhythm: string;
  totalPriceForStayWithTaxes: number;
  pim?: { rules?: { maxQuantity?: number } };
}

export function getExtraUiType(extra: IExtraLike): ExtraUiType {
  if (extra.calculationRule === 'reservation' && extra.postingRhythm === 'stay') return 'incrementor';
  return 'fixed';
}

export function getAutoQty(extra: IExtraLike, adults: number, children: number): number {
  if (extra.calculationRule === 'adult') return adults;
  if (extra.calculationRule === 'child') return children;
  if (extra.calculationRule === 'person') return adults + children;
  return 1;
}

export function getExtraMaxQty(extra: IExtraLike, nights: number, persons: number): number {
  const pimMax = extra.pim?.rules?.maxQuantity;
  if (extra.calculationRule === 'person') {
    const calcMax = extra.postingRhythm === 'day' ? persons * nights : persons;
    return pimMax !== undefined ? Math.min(pimMax, calcMax) : calcMax;
  }
  return pimMax ?? Math.max(persons, 1);
}

export function computeUnitPrice(
  extra: IExtraLike,
  nights: number,
  adults: number,
  children: number
): number {
  const total = extra.totalPriceForStayWithTaxes;
  const persons = adults + children;
  const { calculationRule: rule, postingRhythm: rhythm } = extra;

  if (rhythm === 'day') {
    if (rule === 'adult' && adults > 0) return total / (adults * nights);
    if (rule === 'child' && children > 0) return total / (children * nights);
    if (rule === 'person' && persons > 0) return total / (persons * nights);
    if ((rule === 'reservation' || rule === 'room') && nights > 0) return total / nights;
  }
  if (rhythm === 'stay') {
    if (rule === 'adult' && adults > 0) return total / adults;
    if (rule === 'child' && children > 0) return total / children;
    if (rule === 'person' && persons > 0) return total / persons;
  }
  // reservation/room per stay, or any unhandled combination: unit price == total (flat rate)
  return total;
}
